<!-- @format -->

<fudis-footer *transloco="let t" class="sis-footer">
  <a
    fudisLink
    class="promo-link"
    [title]="t('SIS_COMPONENTS.NAVIGATION.JOIN_FUNILAB')"
    [external]="true"
    [href]="'https://digitalist.leanlab.co/cgi/view?sid=20b01d167963a06a'"></a>
  @if (moduleToggleOverridesAllowed) {
    <a fudisLink [title]="t('SIS_COMPONENTS.NAVIGATION.FEATURE_TOGGLE_URL')" [href]="moduleToggleOverridesUrl"></a>
  }
  @if (feedbackEnabled()) {
    <a fudisLink [title]="t('SIS_COMPONENTS.NAVIGATION.FEEDBACK')" [uiSref]="feedbackState" data-cy="footer-feedback-link"></a>
  }
  @if (registryDescriptionUrl()) {
    <a
      fudisLink
      [title]="t('SIS_COMPONENTS.NAVIGATION.REGISTRY_DESCRIPTION_URL')"
      [external]="true"
      [href]="registryDescriptionUrl() + '?lang=' + currentLanguage()"></a>
  }
  <a
    fudisLink
    [title]="t('SIS_COMPONENTS.NAVIGATION.ACCESSIBILITY_STATEMENT_URL')"
    [external]="true"
    [href]="'/accessibility-statement/' + currentLanguage()"></a>
  @if (aboutHref) {
    <a fudisLink [title]="t('ABOUT.TITLE')" [href]="aboutHref"></a>
  }
</fudis-footer>
